const CardsActionTypes = {
    START_GET_CARD: 'START_GET_CARD',
    SUCCESS_GET_CARD: 'SUCCESS_GET_CARD',

    GET_CARD_PROGRAMS: 'GET_CARD_PROGRAMS',
    SUCCESS_CARD_PROGRAMS: 'SUCCESS_CARD_PROGRAMS',

    GET_CARD_SHIPPING: 'GET_CARD_SHIPPING',
    SUCCESS_CARD_SHIPPING: 'SUCCESS_CARD_SHIPPING',

    START_CARD_ORDER: 'START_CARD_ORDER',
    SUCCESS_CARD_ORDER: 'SUCCESS_CARD_ORDER',
    FINISH_CARD_ORDER: 'FINISH_CARD_ORDER',
    FAILURE_CARD_ORDER: 'FAILURE_CARD_ORDER',

    START_CARD_TOP_UP: 'START_CARD_TOP_UP',
    SUCCESS_CARD_TOP_UP: 'SUCCESS_CARD_TOP_UP',
    FINISH_CARD_TOP_UP: 'FINISH_CARD_TOP_UP',
    FAILURE_CARD_TOP_UP: 'FAILURE_CARD_TOP_UP',

    START_CARD_WITHDRAW: 'START_CARD_WITHDRAW',
    SUCCESS_CARD_WITHDRAW: 'SUCCESS_CARD_WITHDRAW',
    FINISH_CARD_WITHDRAW: 'FINISH_CARD_WITHDRAW',
    FAILURE_CARD_WITHDRAW: 'FAILURE_CARD_WITHDRAW',

    START_CARD_FREEZE: 'START_CARD_FREEZE',
    SUCCESS_CARD_FREEZE: 'SUCCESS_CARD_FREEZE',
    FINISH_CARD_FREEZE: 'FINISH_CARD_FREEZE',
    FAILURE_CARD_FREEZE: 'FAILURE_CARD_FREEZE',

    START_CARD_UNFREEZE: 'START_CARD_UNFREEZE',
    SUCCESS_CARD_UNFREEZE: 'SUCCESS_CARD_UNFREEZE',
    FINISH_CARD_UNFREEZE: 'FINISH_CARD_UNFREEZE',
    FAILURE_CARD_UNFREEZE: 'FAILURE_CARD_UNFREEZE',

    START_CARD_ACTIVATION: 'START_CARD_ACTIVATION',
    SUCCESS_CARD_ACTIVATION: 'SUCCESS_CARD_ACTIVATION',
    FINISH_CARD_ACTIVATION: 'FINISH_CARD_ACTIVATION',
    FAILURE_CARD_ACTIVATION: 'FAILURE_CARD_ACTIVATION',

    START_CARD_DEACTIVATE: 'START_CARD_DEACTIVATE',
    SUCCESS_CARD_DEACTIVATE: 'SUCCESS_CARD_DEACTIVATE',
    FINISH_CARD_DEACTIVATE: 'FINISH_CARD_DEACTIVATE',
    FAILURE_CARD_DEACTIVATE: 'FAILURE_CARD_DEACTIVATE',

    START_CARD_DETAILS: 'START_CARD_DETAILS',
    SUCCESS_CARD_DETAILS: 'SUCCESS_CARD_DETAILS',
    FINISH_CARD_DETAILS: 'FINISH_CARD_DETAILS',
    FAILURE_CARD_DETAILS: 'FAILURE_CARD_DETAILS',

    START_RECEIVE_PIN: 'START_RECEIVE_PIN',
    SUCCESS_RECEIVE_PIN: 'SUCCESS_RECEIVE_PIN',
    FINISH_RECEIVE_PIN: 'FINISH_RECEIVE_PIN',
    FAILURE_RECEIVE_PIN: 'FAILURE_RECEIVE_PIN',
}

export default CardsActionTypes
